/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelUpcomingActivities.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/upcoming-activities";

export class AutogenModelUpcomingActivities<RowType extends ModelRow> extends Endpoint<RowType, RowUpcomingActivitiesFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowUpcomingActivities extends ModelRow<RowUpcomingActivitiesFields> {
	constructor(values?: Partial<RowUpcomingActivitiesFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowUpcomingActivitiesFields {
	action_date: Date;
	activity_id: string;
	call_length: number;
	carrier_id: string;
	company_id: string;
	customer_id: string;
	date_due: Date;
	descr: string;
	email: string;
	id: string;
	info_packet_id: string;
	mark_plan_id: string;
	next_act_date: Date;
	next_act_id: string;
	next_action: string;
	objection_id1: string;
	objection_id2: string;
	operations_user: string;
	opportunity_id: number;
	phone: string;
	primary_contact: string;
	priority: string;
	remarks: string;
	salesperson_id: string;
	start_date: Date;
	status: string;
	windows_task_id: number;
}

